/** Client capabilities advertised to the language server (what the Monaco bindings in providers.ts actually implement). */
export const CLIENT_CAPABILITIES = {
  general: { positionEncodings: ["utf-16"] },
  workspace: { applyEdit: true, workspaceEdit: { documentChanges: true }, configuration: true, workspaceFolders: true },
  textDocument: {
    synchronization: { didSave: true, dynamicRegistration: false, willSave: false },
    completion: {
      completionItem: {
        snippetSupport: true,
        documentationFormat: ["markdown", "plaintext"],
        deprecatedSupport: true,
        tagSupport: { valueSet: [1] },
        insertReplaceSupport: true,
        resolveSupport: { properties: ["documentation", "detail", "additionalTextEdits"] },
        labelDetailsSupport: true,
        preselectSupport: true,
      },
      contextSupport: true,
    },
    hover: { contentFormat: ["markdown", "plaintext"] },
    signatureHelp: {
      signatureInformation: {
        documentationFormat: ["markdown", "plaintext"],
        parameterInformation: { labelOffsetSupport: true },
        activeParameterSupport: true,
      },
      contextSupport: true,
    },
    definition: { linkSupport: false },
    references: {},
    rename: { prepareSupport: true },
    codeAction: {
      codeActionLiteralSupport: {
        codeActionKind: {
          valueSet: ["", "quickfix", "refactor", "refactor.extract", "refactor.inline", "refactor.rewrite", "source", "source.organizeImports"],
        },
      },
      isPreferredSupport: true,
      disabledSupport: true,
    },
    publishDiagnostics: { relatedInformation: true, tagSupport: { valueSet: [1, 2] } },
  },
  window: { workDoneProgress: false },
} as const;

export const LSP_REQUEST_TIMEOUT_MS = 30_000;
